import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "environments/environment";

export const authConfig: AuthConfig = {
  responseType: "code",
  scope: environment.oauthParameter.scope,
  // to prevent location.hash = '' to cancel the navigation to the previous url (see https://github.com/manfredsteyer/angular-oauth2-oidc/issues/424#issuecomment-431797618)
  clearHashAfterLogin: false,
  //    loginUrl: environment.oauthParameter.loginUrl,
  // Url of the Identity Provider
  issuer: environment.oauthParameter.issuer,
  // URL of the SPA to redirect the user to after login
  redirectUri: environment.oauthParameter.redirectUri,
  postLogoutRedirectUri: environment.oauthParameter.logoutUrl,
  // The SPA's id. The SPA is registered with this id at the auth-server
  clientId: environment.oauthParameter.clientId,
  sessionChecksEnabled: false, // false is expected here since idp used is not from same domain as us
  showDebugInformation: environment.oauthParameter.showDebugInformation,
  customQueryParams: environment.oauthParameter.customQueryParams,
  useSilentRefresh: true,
  silentRefreshRedirectUri: environment.oauthParameter.silentRefreshRedirectUri,
  silentRefreshShowIFrame: false, // for debugging
  // timeoutFactor: 0.01, // will trigger silent refresh each 3 min in dev
  checkOrigin: false, // false is expected here since idp used is not from same domain as us
};
